import { UrlHelper } from '../../hoc/UrlHelper';
import { history } from '../../wlHistory';

const methods = {
  goTo: function (url, openInNewTab = false) {
    console.log('goTo: ', url);
    if (openInNewTab) {
      return window.open(url, '_blank');
    } else {
      if (PLATFORM === 'cordova' && url.includes('/invite/')) {
        if (url.includes('http')) {
          window.open(url, '_system');
        } else {
          const fixedPath = url.startsWith('/') ? url : `/${url}`;
          window.open(`${URL_HOST}${fixedPath}`, '_system');
        }
        return;
      }
      if (url.indexOf('http') > -1) {
        const { pathname } = new URL(url);
        return history.push(pathname);
      } else {
        return history.push(url);
      }
    }
  },
  goBack: function () {
    if (window.location.href.indexOf('/messages/') >= 0) {
      history.push('/messages/');
      return;
    }
    if (window.location.href.indexOf('/action/') >= 0) {
      history.push('/action/');
      return;
    }
    if (window.location.href.indexOf('/schedule/') >= 0) {
      history.push('/schedule/');
      return;
    }
  },
  howItWorks: function () {
    methods.goTo(UrlHelper.url('/info/how-it-works/'), true);
  },
  myOffers: function () {
    methods.goTo(UrlHelper.url('/dashboard/listings/'));
  },
  withlocals: function () {
    methods.goTo(UrlHelper.getBaseUrl());
  },
  myAssignments: function () {
    methods.goTo(UrlHelper.url('/dashboard/hosts/'));
  },
  help: function () {
    methods.goTo('https://support.withlocals.com', true);
  },
  findThingsToDoIn: function (country, city) {
    let url = `/s/`;
    if (!!country) {
      url += `${country.replace(/ /g, '-').toLowerCase()}/`;
      if (!!city) {
        url += `${city.replace(/ /g, '-').toLowerCase()}/`;
      }
    }

    methods.goTo(url);
  },
  toSelectedSchedule(bookingId, search) {
    const url = `/schedule/${bookingId}/details/`;
    history.push({ pathname: url, search: search });
  },
  toSelectedMessage(contactId) {
    const url = `/messages/${contactId}/chat/`;
    history.push(url, {
      url,
      contactId,
    });
  },
};

export default {
  menu: methods,
};
